import { Trans, useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import { PlayTriangleIcon, CheckCircleOpenIcon } from 'icons';
import { colors } from 'styles/colors';

import {
  ResultWrap, ResultIconWrap, ResultBody, ResultTitle, ResultDesc, ResultMeta,
  StatusBadge, BadgeDot,
  BtnOutline,
} from '../../styles';

interface WaitingStateProps {
  completedAt: string | null;
  timezoneArea?: string | null;
  onRestartClick: () => void;
}

export const WaitingState = ({ completedAt, timezoneArea, onRestartClick }: WaitingStateProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ResultWrap>
      <ResultIconWrap $variant="positive">
        <CheckCircleOpenIcon width={24} height={24} color={colors.LightBlue} />
      </ResultIconWrap>
      <ResultBody>
        <ResultTitle>{t('manutencaoValidadaComSucesso')}</ResultTitle>
        <ResultDesc><Trans i18nKey="validacaoPositivaDescricao" components={{ strong: <strong /> }} /></ResultDesc>
        <StatusBadge $variant="positive">
          <BadgeDot />
          {t('maquinaEmValidacao')}
        </StatusBadge>
        {completedAt && (
          <ResultMeta>
            {t('validacaoConcluidaEm', {
              datetime: (timezoneArea ? moment.tz(completedAt, timezoneArea) : moment(completedAt)).format('DD/MM/YYYY, HH:mm'),
              interpolation: { escapeValue: false },
            })}
          </ResultMeta>
        )}
      </ResultBody>
      <BtnOutline onClick={onRestartClick}>
        <PlayTriangleIcon color={colors.brand.principal} />
        {t('reiniciarValidacao')}
      </BtnOutline>
    </ResultWrap>
  );
};
